:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._mobileWizardLastStep_145ew_7 ._stepHeaderWrapper_145ew_7 {
  text-align: center;
  padding-top: 18px; }
  ._mobileWizardLastStep_145ew_7 ._stepHeaderWrapper_145ew_7 ._stepHeader_145ew_7 {
    padding-bottom: 7px; }
  ._mobileWizardLastStep_145ew_7 ._stepHeaderWrapper_145ew_7 ._stepSubHeader_145ew_12 {
    height: 48px;
    max-height: 48px;
    overflow: hidden; }

._mobileWizardLastStep_145ew_7 ._mobileWizardLastStepVideo_145ew_17 {
  width: 482px;
  height: 271px;
  box-shadow: 0 0 4px 1px rgba(17, 91, 154, 0.1), 0 0 18px 2px rgba(17, 91, 154, 0.1);
  margin-bottom: 2px; }
